export interface AgentHostStatus {
  available: boolean;
  running: boolean;
  config_path: string;
  exe_path: string | null;
  error: string | null;
}

export interface AgentHostDoctorResult {
  ok: boolean;
  stdout: string;
  stderr: string;
}

type InvokeFn = <T>(cmd: string, payload?: Record<string, unknown>) => Promise<T>;

declare global {
  interface Window {
    __TAURI__?: {
      core?: {
        invoke?: InvokeFn;
      };
    };
    __TAURI_INTERNALS__?: {
      invoke?: InvokeFn;
    };
  }
}

export function isTauriDesktop(): boolean {
  return Boolean(getInvoke());
}

export function getAgentHostStatus(): Promise<AgentHostStatus> {
  return invokeTauri("agent_host_status");
}

export function saveAgentHostConfig(toml: string): Promise<string> {
  return invokeTauri("agent_host_save_config", { toml });
}

export function doctorAgentHost(): Promise<AgentHostDoctorResult> {
  return invokeTauri("agent_host_doctor");
}

export function startAgentHost(): Promise<AgentHostStatus> {
  return invokeTauri("agent_host_start");
}

export function stopAgentHost(): Promise<AgentHostStatus> {
  return invokeTauri("agent_host_stop");
}

export function restartAgentHost(): Promise<AgentHostStatus> {
  return invokeTauri("agent_host_restart");
}

export function readAgentHostBootLog(): Promise<string> {
  return invokeTauri("agent_host_read_boot_log");
}

export function clearAgentHostBootLog(): Promise<void> {
  return invokeTauri("agent_host_clear_boot_log");
}

async function invokeTauri<T>(
  cmd: string,
  payload?: Record<string, unknown>,
): Promise<T> {
  const invoke = getInvoke();
  if (!invoke) {
    throw new Error("当前不是 Tauri 桌面环境");
  }
  return invoke<T>(cmd, payload);
}

function getInvoke(): InvokeFn | null {
  return (
    window.__TAURI__?.core?.invoke ??
    window.__TAURI_INTERNALS__?.invoke ??
    null
  );
}
